import React from 'react';

function CommentThread({ comments }) {
  return (
    <div style={{ marginTop: '2rem' }}>
      <h4>Comments</h4>
      {comments?.length === 0 ? (
        <p>No comments yet.</p>
      ) : (
        comments.map(comment => (
          <div
            key={comment.commentId}
            style={{
              marginBottom: '1rem',
              padding: '0.75rem',
              border: '1px solid #ddd',
              borderRadius: '6px',
              backgroundColor: '#fdfdfd'
            }}
          >
            <p style={{ marginBottom: '0.25rem' }}>
              <strong>{comment.authorName || 'User'}:</strong> {comment.text}
            </p>

            {comment.replies.length > 0 && (
              <div style={{ marginLeft: '1rem', marginTop: '0.5rem' }}>
                {comment.replies.map(reply => (
                  <div
                    key={reply.replyId}
                    style={{
                      padding: '0.5rem',
                      borderLeft: '2px solid #ccc',
                      marginBottom: '0.5rem',
                      backgroundColor: '#f5f7fa',
                      borderRadius: '4px'
                    }}
                  >
                    <p style={{ margin: 0 }}>
                      <strong>{reply.authorName || 'User'} ↳</strong> {reply.text}
                    </p>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))
      )}
    </div>
  );
}

export default CommentThread;
